import React from 'react';
import { Box, Divider, LinearProgress, Paper, Stack, Typography } from '@mui/material';

const WIDTHS = {
  small: 700,
  standard: 1000,
  wide: 1400,
};

export default function ETVPage({
  width = 'standard',
  icon,
  title,
  description,
  loading = false,
  topActions,
  bottomActions,
  children,
  sx,
}) {
  const maxWidth = WIDTHS[width] || WIDTHS.standard;

  return (
    <Box sx={{width:'calc(100% - 32px)',maxWidth,mt:1,mb:2,ml:2,boxSizing:'border-box'}}>
      <Paper variant="outlined" sx={{borderRadius:4,overflow:'hidden',boxShadow:'0 10px 30px rgba(31, 41, 55, 0.08)',...sx}}>
        <Box sx={{p:{xs:2,md:3.5},pb:{xs:2,md:2.5}}}>
          <Stack direction={{xs:'column',sm:'row'}} alignItems={{xs:'stretch',sm:'center'}} justifyContent="space-between" spacing={2}>
            <Stack direction="row" alignItems="center" spacing={1.25} sx={{minWidth:0}}>
              {icon && <Box sx={{display:'flex',color:'primary.main',flexShrink:0}}>{icon}</Box>}
              <Box sx={{minWidth:0}}>
                <Typography variant="h5" fontWeight={700}>{title}</Typography>
                {description && <Typography variant="body2" color="text.secondary" sx={{mt:0.5}}>{description}</Typography>}
              </Box>
            </Stack>
            {topActions && <Stack direction="row" spacing={1} flexWrap="wrap" useFlexGap justifyContent={{xs:'flex-start',sm:'flex-end'}}>{topActions}</Stack>}
          </Stack>
        </Box>

		<Divider />
        <LinearProgress
          aria-hidden={!loading}
          sx={{ visibility: loading ? 'visible' : 'hidden' }}
        />

		<Box sx={{px:{xs:2,md:3.5},pt:{xs:2,md:3},pb:{xs:2,md:3.5}}}>{children}</Box>

        {bottomActions && <><Divider/><Stack direction="row" spacing={1} justifyContent="flex-end" sx={{p:{xs:2,md:2.5}}}>{bottomActions}</Stack></>}
      </Paper>
    </Box>
  );
}
